const zIndexes = {
  dropdownBackdrop: 90,
  dropdown: 100,
  sticky: 200,
  modalBackdrop: 500,
  modal: 510,
  notification: 610
};
export {
  zIndexes
};
